<template>
  <div class="main">
    <div class="banner">
      <h3 class="banner-title">慢病管理解决方案</h3>
      <p class="banner-desc">帮助慢病顾客改善服药依从性，改善生活型态，改善疗效，减少并发症；提升会员粘度和光顾频次；提升药房专业服务力，塑造药房专业形象</p>
      <router-link class="banner-btn" to="/try">申请使用</router-link>
    </div>

    <div class="ncd">
      <div class="ncd-container w">
        <div class="m-title">
          <h2>三大慢病管理 锁定主要消费群体</h2>
          <p>CHRONIC DISEASE MANAGEMENT</p>
        </div>
        <ul class="ncd-list">
          <li class="ncd-item">
            <svg-icon icon-class="solve_ncd_icon1" class-name="ncd-pic"></svg-icon>
            <h3 class="ncd-title">高血压</h3>
            <p class="ncd-desc">高血压是人类最常见的心血管系统疾病，是导致冠心病、心肌梗死、脑卒中、肾功能不全甚至死亡的重要危险因素</p>
          </li>
          <li class="ncd-item">
            <svg-icon icon-class="solve_ncd_icon2" class-name="ncd-pic"></svg-icon>
            <h3 class="ncd-title">糖尿病</h3>
            <p class="ncd-desc">糖尿病是一组由多病因引起的,以慢性高血糖为特征的代谢疾病,可引起多系统损害,导致眼、肾、心脏、血管等组织器官进行性病变</p>
          </li>
          <li class="ncd-item">
            <svg-icon icon-class="solve_ncd_icon3" class-name="ncd-pic"></svg-icon>
            <h3 class="ncd-title">骨质疏松</h3>
            <p class="ncd-desc">骨质疏松是一种以骨量低下，骨微结构损坏，导致骨脆性增加易发生骨折为特征的全身性骨病，导致骨折性风险增加</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="health">
      <div class="health-container w">
        <div class="m-title">
          <h2>
            八大健康管理
            <br />涵盖最有价值的潜在消费群体
          </h2>
          <p>HEALTH MANAGEMENT</p>
        </div>

        <ul class="health-list">
          <li class="health-item">
            <p class="health-title">体重</p>
            <p class="health-capital">WEIGHT</p>
          </li>
          <li class="health-item">
            <p class="health-title">容颜</p>
            <p class="health-capital">FACE</p>
          </li>
          <li class="health-item">
            <p class="health-title">骨骼</p>
            <p class="health-capital">BONES</p>
          </li>
          <li class="health-item">
            <p class="health-title">压力</p>
            <p class="health-capital">PRESSURE</p>
          </li>
          <li class="health-item">
            <p class="health-title">血压</p>
            <p class="health-capital">BP</p>
          </li>
          <li class="health-item">
            <p class="health-title">血糖</p>
            <p class="health-capital">GLU</p>
          </li>
          <li class="health-item">
            <p class="health-title">生活形态</p>
            <p class="health-capital">LIFESTYLE</p>
          </li>
          <li class="health-item">
            <p class="health-title">九型体质</p>
            <p class="health-capital">PHYSIQUE</p>
          </li>
        </ul>

        <ul class="benefit-list">
          <li class="benefit-item">
            <h3 class="benefit-num">1</h3>
            <div class="benefit-title">帮助顾客改善生活型态</div>
            <div class="benefit-desc">改善健康状况,降低疾病风险</div>
          </li>
          <li class="benefit-item">
            <h3 class="benefit-num">2</h3>
            <div class="benefit-title">挖掘最核心会员潜在价值</div>
            <div class="benefit-desc">提升会员粘度和光顾频次</div>
          </li>
          <li class="benefit-item">
            <h3 class="benefit-num">3</h3>
            <div class="benefit-title">提升药房专业服务力</div>
            <div class="benefit-desc">塑造药房专业形象</div>
          </li>
        </ul>
      </div>
    </div>

    <div class="fun">
      <div class="fun-container w">
        <ul class="fun-list">
          <li class="fun-item">
            <div class="fun-item-top">
              <div class="fun-item-svg">
                <svg-icon icon-class="solve_fun_icon1" class-name="fun-icon"></svg-icon>
              </div>
              <div class="fun-item-title">慢病专员作业功能</div>
            </div>
            <div class="fun-item-middle">
              <svg-icon icon-class="solve_fun_pic1" class-name="fun-pic1"></svg-icon>
            </div>
            <div class="fun-item-desc">
              <p>完善的智能工作台:慢病管理/健康管理/健康检测与评估作业/智能报表统计分析</p>
              <p>支持多硬件:支持电脑、IPAD应用，顾客自我管理AP应用</p>
            </div>
          </li>
          <li class="fun-item">
            <div class="fun-item-top">
              <div class="fun-item-svg">
                <svg-icon icon-class="solve_fun_icon2" class-name="fun-icon"></svg-icon>
              </div>
              <div class="fun-item-title">连锁总部管理功能</div>
            </div>
            <div class="fun-item-middle">
              <svg-icon icon-class="solve_fun_pic2" class-name="fun-pic2"></svg-icon>
            </div>
            <div class="fun-item-desc">
              <p>考核与绩效管理、关联品类商品管理</p>
              <p>基础信息管理:门店/专员/病种与项目/会员大数据分析</p>
            </div>
          </li>
          <li class="fun-item">
            <div class="fun-item-top">
              <div class="fun-item-svg">
                <svg-icon icon-class="solve_fun_icon3" class-name="fun-icon"></svg-icon>
              </div>
              <div class="fun-item-title">分析报表自动生成</div>
            </div>
            <div class="fun-item-middle">
              <svg-icon icon-class="solve_fun_pic3" class-name="fun-pic3"></svg-icon>
            </div>
            <div class="fun-item-desc">
              <p>会员数据统计分析、销售数据统计分析</p>
              <p>关联品类销售成长分析、顾客满意度结果统计分析</p>
            </div>
          </li>
          <li class="fun-item">
            <div class="fun-item-top">
              <div class="fun-item-svg">
                <svg-icon icon-class="solve_fun_icon4" class-name="fun-icon"></svg-icon>
              </div>
              <div class="fun-item-title">大数据分析</div>
            </div>
            <div class="fun-item-middle">
              <svg-icon icon-class="solve_fun_pic4" class-name="fun-pic4"></svg-icon>
            </div>
            <div class="fun-item-desc">
              <p>会员区隔分析、服药顺从度分析</p>
              <p>顾客忠诚度分析、全国与区域参考值</p>
            </div>
          </li>
          <li class="fun-item">
            <div class="fun-item-top">
              <div class="fun-item-svg">
                <svg-icon icon-class="solve_fun_icon5" class-name="fun-icon"></svg-icon>
              </div>
              <div class="fun-item-title">提高效率与精准度</div>
            </div>
            <div class="fun-item-middle">
              <svg-icon icon-class="solve_fun_pic5" class-name="fun-pic5"></svg-icon>
            </div>
            <div class="fun-item-desc">
              <p>省时省力的档案维护与管理、健康/慢病管理评估报告自动生成</p>
              <p>顾客/病患自我管理APP、追踪回访日程提醒、个性化短信发送</p>
            </div>
          </li>
          <li class="fun-item">
            <div class="fun-item-top">
              <div class="fun-item-svg">
                <svg-icon icon-class="solve_fun_icon6" class-name="fun-icon"></svg-icon>
              </div>
              <div class="fun-item-title">创造更多的经济效益</div>
            </div>
            <div class="fun-item-middle">
              <svg-icon icon-class="solve_fun_pic6" class-name="fun-pic6"></svg-icon>
            </div>
            <div class="fun-item-desc">
              <p>节省人力，提高效率</p>
              <p>实时发现问题/采取改进行动、创造厂商合作机会</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    document.querySelector("body").setAttribute("style", "background:#f4f5f6");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  }
};
</script>
<style lang='scss' scoped>
.banner {
  width: 100%;
  height: 752px;
  background: #f29b33 url("../../assets/imgs/m_banner_bg.png") no-repeat top
    center / 100%;
  padding: 170px 0;
  .banner-title {
    font-size: 64px;
    color: #fff;
    line-height: 90px;
    text-align: center;
    font-weight: 400;
  }
  .banner-desc {
    width: 650px;
    margin: 50px auto 42px;
    color: #fff;
    font-size: 30px;
    line-height: 58px;
  }
  .banner-btn {
    display: block;
    margin: 0 auto;
    width: 192px;
    height: 64px;
    background: #fff;
    border-radius: 4px;
    color: #f08300;
    font-size: 32px;
    text-align: center;
    line-height: 64px;
  }
}

.ncd {
  padding: 88px 0 72px;
  .ncd-list {
    width: 100%;
    margin: 0 auto;
    .ncd-item {
      width: 624px;
      height: 616px;
      background: #fff;
      box-shadow: 0px 30px 40px 0px rgba(240, 131, 0, 0.05);
      border-radius: 8px;
      padding: 96px 48px;
      margin: 0 auto 48px;
      .ncd-pic {
        display: block;
        margin: 0 auto;
        width: 160px;
        height: 160px;
        background: #f4f5f6;
        border-radius: 50%;
      }
      .ncd-title {
        font-size: 48px;
        font-weight: bold;
        color: #2f393f;
        line-height: 66px;
        margin: 24px auto;
        text-align: center;
      }
      .ncd-desc {
        font-size: 28px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 50px;
      }
    }
  }
}

.health {
  .health-list {
    @include clearfix;
    padding: 0 32px;
    .health-item {
      float: left;
      width: 140px;
      height: 140px;
      border-radius: 50%;
      background: #6f94f0;
      overflow: hidden;
      margin-bottom: 48px;
      &:not(:nth-child(4n)) {
        margin-right: 42px;
      }

      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3) {
        background: #6f94f0;
      }
      &:nth-child(4),
      &:nth-child(5) {
        background: #51c1f3;
      }
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        background: #47d38e;
      }
      .health-title {
        margin-top: 24px;
        text-align: center;
        font-size: 32px;
        font-weight: 400;
        color: #fff;
        line-height: 40px;
      }
      .health-capital {
        margin-top: 4px;
        font-size: 24px;
        font-weight: 400;
        color: #fff;
        line-height: 40px;
        text-align: center;
      }
    }
  }

  .benefit-list {
    margin-top: 64px;
    .benefit-item {
      width: 686px;
      height: 460px;
      background: #fff;
      box-shadow: 0px 30px 40px 0px rgba(240, 131, 0, 0.05);
      border-radius: 8px;
      margin: 0 auto 48px;
      overflow: hidden;
      .benefit-num {
        margin-top: 46px;
        font-size: 128px;
        color: #f08300;
        line-height: 148px;
        text-align: center;
      }
      .benefit-title {
        margin-top: 10px;
        font-size: 60px;
        font-weight: bold;
        color: #f08300;
        line-height: 84px;
        text-align: center;
      }

      .benefit-desc {
        margin-top: 24px;
        font-size: 40px;
        font-weight: 400;
        color: #2f393f;
        line-height: 56px;
        text-align: center;
      }
    }
  }
}

.fun-container {
  padding: 0 40px;
  .fun-list {
    margin-top: 128px;
    .fun-item {
      margin-bottom: 64px;
      padding-bottom: 16px;
      &:not(:last-child) {
        border-bottom: 2px solid #d8d8d8;
      }
      .fun-item-top {
        display: flex;
        .fun-item-svg {
          width: 142px;
          height: 142px;
          background: #f08300;
          border-radius: 50%;
          margin-right: 32px;
          .fun-icon {
            width: 142px;
            height: 142px;
          }
        }

        .fun-item-title {
          font-size: 48px;
          font-weight: 300;
          color: #2f393f;
          line-height: 142px;
        }
      }

      .fun-item-middle {
        margin-top: 48px;
        .fun-pic1 {
          width: 100%;
          height: 600px;
        }
        .fun-pic2 {
          width: 100%;
          height: 600px;
        }
        .fun-pic3 {
          width: 100%;
          height: 518px;
        }
        .fun-pic4 {
          width: 100%;
          height: 444px;
        }
        .fun-pic5 {
          width: 100%;
          height: 516px;
        }
        .fun-pic6 {
          width: 100%;
          height: 510px;
        }
      }

      .fun-item-desc {
        font-size: 28px;
        color: #8a857d;
        line-height: 50px;
        margin-top: 48px;
      }
    }
  }
}
</style>